// Copyright (c) 2025 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.
import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const LabelTag = ({ label, color }: { label: string; color?: (theme: Theme) => string }) => {
  return (
    <Typography
      data-testid="label-tag"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: color ? color : (theme) => theme.palette.grey[800],
        color: 'white',
        borderRadius: '4px',
        px: '8px',
        height: '28px',
        width: 'fit-content',
      }}
      variant="caption"
      fontWeight={600}
    >
      {label}
    </Typography>
  );
};
